import React from "react";
import EditReportForm from "../../../components/ScoutingReports/EditReoprtForm";

const EditReport = () => {
    
  return (
    <div>
      <EditReportForm />
    </div>
  );
};

export default EditReport;
